import { StatusData } from "../../model"

export const mapGetStatusDataResponse = ({ telematicsDeviceVoltage, location, ...rest }: any): StatusData => ({
    ...rest,
    gpsPositions: location,
    telematicsDeviceVoltage: +telematicsDeviceVoltage,
})
